class TourDef {
    constructor() {
        this.runTours = true;
        this.tours = new Map();
        this.tours.set(
            "Home",
            {
                steps: [
                    {
                        target: '.tour_home',
                        title: 'Clear Child Assessment Home',
                        content: "Welcome to Clear Child CADE!  We'll briefly describe the features to get you going quickly!",
                    },
                    {
                        target: '.tour_homeProfile',
                        content: 'When you are done, go here to log out. Also, here is where you can modify your profile (including setting your password), view helpful videos, and more.',
                    },
                    {
                        target: '.tour_homeCadeLogo',
                        content: 'You can always click on our logo to get back to the home screen.',
                        isFixed: true,
                    },
                    {
                        target: '.tour_homeAddPerson',
                        content: "Click here to add new child or client information.",
                    },
                    {
                        target: '.tour_homeExistingPerson',
                        content: "The children or clients that you add will show up in this list. Clicking on the person's name will then show all of their assessments below.",
                        placement: "bottom"
                    },
                    {
                        target: '.tour_homeAssessments',
                        content: "This area shows all of the assessments for the selected person, most recent first.  Measure progress over time by having more than one assessment!",
                    },
                    {
                        target: '.tour_homeAccess',
                        content: "Assessment owners only:  This button allows you to set who is allowed to access your assessment.  It allows you to specify 'raters' - other people that you want to contribute to your assessment.",
                    },
                    {
                        target: '.tour_homeArchive',
                        content: "Assessment owners only:  If you make a mistake creating an assessment or, for any reason, want to remove an assessment, click here.  You will be prompted to confirm the removal because this action cannot be reversed.",
                    },
                    {
                        target: '.tour_homeAssessments',
                        content: "Let’s get started! Click on the words “Click to Open” right next to the assessment date."
                    }
                ]
            }
        );

        this.tours.set(
            "Input",
            {
                steps: [
                    {
                        target: '.tour_input',
                        title: 'Clear Child Assessment Input',
                        content: "This is where you provide your assessment input or see the input of raters.  Before describing the features of this page, let's go over some basics.",
                    },
                    {
                        target: '.tour_modeNavigation',
                        content: 'The top menu allows you to select what you want to do: provide input, analyze results, monitor progress or generate reports.',
                        isFixed: true,
                        placement: 'bottom'
                    },
                    {
                        target: '.tour_domainNavigation',
                        content: 'The sidebar allows you to go to a specific Clear Child Domain. Combined with the top menu choice, you can input, analyze, monitor or report on the selected domain or on the assessment as a whole.',
                        placement: 'right-start',
                        isFixed: true,
                    },
                    {
                        target: '.tour_cadeLogo',
                        content: 'Click on the CADE logo to return to your list of children and their assessments.',
                        placement: 'right',
                        isFixed: true,
                    },
                    {
                        target: '.tour_inputItem',
                        content: "Each domain has a different set of assessment questions.  If you need more help answering the question, click on the '?' icon by the question.",
                    },
                    {
                        target: '.tour_inputConcern',
                        content: "Pick your response to each question from a list of choices.  Answer all questions and, if you don't know an answer, select Don't Know.",
                    },
                    {
                        target: '.tour_inputRaters',
                        content: 'If you have asked one or more raters to provide input, you can see their responses here!',
                    },
                    {
                        target: '.tour_inputResources',
                        content: 'Click on the icons in this column in order to get audio, video, document or other, more detailed help for the assessment item.',
                    },
                    {
                        target: '.tour_analyze',
                        content: "When you're done answering the domain's questions, you can click Analyze to analyze results for that domain!  When you have finished all domains, click Analyze to see the results for the entire assessment!",
                    },
                ]
            }
        );

        this.tours.set(
            "Analyze",
            {
                steps: [
                    {
                        target: '.tour_analyze',
                        title: 'Clear Child Assessment Analysis',
                        content: "Here we are, now on the Analyze page!  After responding to the assessment questions for a domain, you can analyze the results here.",
                    },
                    {
                        target: '.tour_navAssessment',
                        content: 'And...after responding to all questions in all Clear Child domains, you can see the analysis for the entire assessment by clicking here.',
                    },
                    {
                        target: '.tour_inputSelectors',
                        content: "Did you notice the new buttons?  These allow you to choose between seeing the analysis based on your input or the input of other raters."
                    },
                    {
                        target: '.tour_analyzeConcernIcon',
                        content: "Based upon the responses, Clear Child determines a concern level (none, mild, moderate, significant).",
                    },
                    {
                        target: '.tour_analyzeRadar',
                        content: "This chart graphically indicates the concern areas.  Each domain item is shown on the outside of the graph.  Color extending to the outside indicates a higher degree of concern; less color means less concern.",
                    },
                    {
                        target: '.tour_analyzeConcernLists',
                        content: 'In this area, you see a list of items having no concerns and, following that, a list of concerns.',
                    },
                    {
                        target: '.tour_analyzeRecommendations',
                        content: 'For any items of concern, we provide recommendations for things you can do at home or at school, written in a way that is clear and easy-to-understand.',
                    },
                    {
                        target: '.tour_report',
                        content: "After reviewing the analysis, you can automatically generate reports.",
                    },
                    {
                        target: '.tour_monitor',
                        content: "Or, once you have created a few different assessments over time, you can monitor progress!",
                    },
                ]
            }
        );

        this.tours.set(
            "Monitor",
            {
                steps: [
                    {
                        target: '.tour_monitor',
                        title: 'Clear Child Progress Monitor',
                        content: "This is the Progress Monitoring page.  Once you have answered the assessment items, you can monitor progress for a single domain or the entire assessment.",
                    },
                    {
                        target: '.tour_pmDates',
                        content: 'Progress monitoring uses the current assessment that you are working on and all assessments prior to determine changes.',
                    },
                    {
                        target: '.tour_pmNavIcon',
                        content: "At a glance, you can see positive, no change or negative progress for the domain.  The color of the circle shows the current concern level."
                    },
                    {
                        target: '.tour_pmConcernLevelChart',
                        content: "This graph shows the concern levels for the domain over time.",
                    },
                    {
                        target: '.tour_pmQoLChart',
                        content: "This chart indicates how the day-to-day life of the individual is progressing over time.",
                    },
                    {
                        target: '.tour_pmItemResponsesChart',
                        content: 'Here you can see the number of item responses in the No Concern, Mild, Moderate or Significant Concern levels.',
                    },
                    {
                        target: '.tour_pmProgressRadarChart',
                        content: 'This chart uses the most recent and least recent assessment to measure progress.',
                    },
                    
                ]
            }
        );

        this.tours.set(
            "Report",
            {
                steps: [
                    {
                        target: '.tour_report',
                        title: 'Clear Child Assessment Reporting',
                        content: "Assessment reports using Clear Child CADE are easy and automatic.  The entire report is generated using your input or other's input (e.g. raters) depending upon your selection.",
                    },
                    {
                        target: '.tour_reportDiagnosticInput',
                        content: "Only write in this box if you plan to generate a diagnostic report."
                    },
                    {
                        target: '.tour_reportSelection',
                        content: 'Click here to select the type of report you want to generate.  After you generate your report, you will see a link to download it to your computer!',
                    },
                    
                ]
            }
        );
    }

    getTours() {
        return this.tours;
    }

    getRunTours() {
        return this.runTours;
    }

    setRunTours(trueOrFalse) {
        this.runTours = trueOrFalse;
    }
}

// This makes it a singleton
const tourDef = new TourDef();
export default tourDef;


// WEBPACK FOOTER //
// ./src/productTour/TourDef.js